import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
var _hoisted_1 = { class: "card" };
var _hoisted_2 = { class: "card-body" };
var _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-3" };
var _hoisted_4 = { class: "table-responsive" };
var _hoisted_5 = { class: "table table-striped table-hover" };
var _hoisted_6 = { class: "d-flex justify-content-center" };
var _hoisted_7 = ["onClick"];
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
    "aria-label": "Paginación",
    class: "d-flex justify-content-start align-items-center mt-3"
};
var _hoisted_10 = { class: "pagination" };
var _hoisted_11 = { class: "page-item" };
var _hoisted_12 = ["disabled"];
var _hoisted_13 = { class: "page-item" };
var _hoisted_14 = ["disabled"];
var _hoisted_15 = { style: { "margin": "0 10px 1rem" } };
var _hoisted_16 = {
    class: "modal fade",
    id: "extendAccount",
    tabindex: "-1",
    "aria-labelledby": "extendAccountLabel",
    "aria-hidden": "true"
};
var _hoisted_17 = { class: "modal-dialog" };
var _hoisted_18 = {
    key: 0,
    class: "modal-content"
};
var _hoisted_19 = { class: "modal-body" };
var _hoisted_20 = { class: "text-center" };
var _hoisted_21 = { class: "d-flex justify-content-center" };
var _hoisted_22 = { style: { "max-width": "260px" } };
var _hoisted_23 = { class: "text-center mt-3" };
var _hoisted_24 = {
    class: "modal fade",
    id: "Historial",
    tabindex: "-1",
    "aria-labelledby": "HistorialLabel",
    "aria-hidden": "true"
};
var _hoisted_25 = { class: "modal-dialog" };
var _hoisted_26 = {
    key: 0,
    class: "modal-content"
};
var _hoisted_27 = { class: "modal-body" };
var _hoisted_28 = { class: "table-responsive" };
var _hoisted_29 = {
    key: 0,
    class: "text-center"
};
var _hoisted_30 = {
    key: 1,
    class: "table table-striped table-hover"
};
import { ref, onMounted } from 'vue';
import { getGroups, extendGroup } from '@/api/admin/platforms';
import { notify } from '@/utils/toast';
import { toast } from 'vue3-toastify';
import { Modal } from 'bootstrap';
import { dateFormat } from '@/utils/dateformat';
import moment from 'moment';
var limit = 10;
export default /*@__PURE__*/ _defineComponent({
    __name: 'Groups',
    setup: function (__props) {
        var _this = this;
        var groups = ref([]);
        var groupSel = ref(null);
        var expiredDate = ref(moment().add(30, 'days').format('YYYY-MM-DD'));
        var page = ref(1);
        var lastPage = ref(1);
        var modalExt = ref(null);
        var modalHis = ref(null);
        onMounted(function () {
            fetchGroup();
        });
        function fetchGroup() {
            return __awaiter(this, void 0, void 0, function () {
                var response, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, getGroups({})];
                        case 1:
                            response = _a.sent();
                            groups.value = response.data.data.rows;
                            lastPage.value = response.data.lastPage;
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            if (error_1.response.status === 401) {
                                notify('No tiene permisos esta solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                            }
                            else if (error_1.response.status === 404) {
                                notify('No existe la solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                            }
                            else {
                                console.error(error_1.message);
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        var openModalExtendAccount = function (record) {
            var _a;
            groupSel.value = record;
            if (modalExt.value === null) {
                var el = document.getElementById('extendAccount');
                console.log(el);
                modalExt.value = el ? new Modal(el) : null;
            }
            (_a = modalExt.value) === null || _a === void 0 ? void 0 : _a.show();
        };
        var openModalHistoricalPay = function (record) {
            var _a;
            groupSel.value = record;
            if (modalHis.value === null) {
                var el = document.getElementById('Historial');
                console.log(el);
                modalHis.value = el ? new Modal(el) : null;
            }
            (_a = modalHis.value) === null || _a === void 0 ? void 0 : _a.show();
        };
        var extendAccountConfirm = function () { return __awaiter(_this, void 0, void 0, function () {
            var status, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, extendGroup(groupSel.value.id, { expiredDate: expiredDate.value })];
                    case 1:
                        status = (_b.sent()).status;
                        if (status === 200) {
                            (_a = modalExt.value) === null || _a === void 0 ? void 0 : _a.hide();
                            fetchGroup();
                            notify('Grupo o cuenta extendida con éxito', 'success', toast.POSITION.BOTTOM_CENTER);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _b.sent();
                        if (error_2.response.status === 401) {
                            notify('No tiene permisos para esta solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else if (error_2.response.status === 404) {
                            notify('No existe la solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else {
                            console.error(error_2.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var nextPage = function () {
            if (page.value < lastPage.value)
                page.value++;
        };
        var previousPage = function () {
            if (page.value > 1)
                page.value--;
        };
        return function (_ctx, _cache) {
            var _component_router_link = _resolveComponent("router-link");
            var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "card-title" }, "Grupos o cuentas", -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1)),
                        _createVNode(_component_router_link, {
                            class: "btn btn-primary",
                            to: "/admin/groups/create"
                        }, {
                            default: _withCtx(function () { return _cache[1] || (_cache[1] = [
                                _createTextVNode("Nuevo Grupo o cuenta")
                            ]); }),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("table", _hoisted_5, [
                            _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", { scope: "col" }, [
                                        _createElementVNode("div", { class: "w-100 text-center" }, "Acciones")
                                    ]),
                                    _createElementVNode("th", { scope: "col" }, "Cuenta"),
                                    _createElementVNode("th", { scope: "col" }, "Nombre"),
                                    _createElementVNode("th", { scope: "col" }, "Perfiles disponibles"),
                                    _createElementVNode("th", { scope: "col" }, "Costo"),
                                    _createElementVNode("th", { scope: "col" }, "Vence"),
                                    _createElementVNode("th", { scope: "col" }, "Estado"),
                                    _createElementVNode("th", { scope: "col" }, "Perfiles usados"),
                                    _createElementVNode("th", { scope: "col" }, "Bloqueado")
                                ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, function (gr) {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: gr.id
                                    }, [
                                        _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'Groups.edit', params: { id: gr.id } },
                                                    class: "btn btn-info btn-md me-2"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(_component_font_awesome_icon, { icon: ['far', 'pen-to-square'] })
                                                    ]; }),
                                                    _: 2
                                                }, 1032, ["to"]),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn-outline-dark btn-md me-2",
                                                    onClick: function ($event) { return (openModalExtendAccount(gr)); }
                                                }, [
                                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'calendar-plus'] })
                                                ], 8, _hoisted_7),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn-outline-info btn-md me-2",
                                                    onClick: function ($event) { return (openModalHistoricalPay(gr)); }
                                                }, [
                                                    _createVNode(_component_font_awesome_icon, { icon: ['far', 'calendar-days'] })
                                                ], 8, _hoisted_8)
                                            ])
                                        ]),
                                        _createElementVNode("td", null, _toDisplayString(gr.accountEmail), 1),
                                        _createElementVNode("td", null, _toDisplayString(gr.groupName), 1),
                                        _createElementVNode("td", null, _toDisplayString(gr.availableProfiles), 1),
                                        _createElementVNode("td", null, _toDisplayString(gr.currentCost), 1),
                                        _createElementVNode("td", null, _toDisplayString(_unref(dateFormat)(gr.expiredAt, 'DD/MMM/YYYY')), 1),
                                        _createElementVNode("td", null, _toDisplayString(gr.status), 1),
                                        _createElementVNode("td", null, _toDisplayString(gr.subscriptions.length), 1),
                                        _createElementVNode("td", null, _toDisplayString(gr.bannedAt === null ? 'No' : gr.bannedAt), 1)
                                    ]));
                                }), 128))
                            ])
                        ])
                    ]),
                    _createElementVNode("nav", _hoisted_9, [
                        _createElementVNode("ul", _hoisted_10, [
                            _createElementVNode("li", _hoisted_11, [
                                _createElementVNode("button", {
                                    class: "page-link",
                                    onClick: previousPage,
                                    disabled: page.value <= 1
                                }, "Anterior", 8, _hoisted_12)
                            ]),
                            _cache[4] || (_cache[4] = _createStaticVNode("<li class=\"page-item\"><button class=\"page-link\" href=\"#\">1</button></li><li class=\"page-item\"><button class=\"page-link\" href=\"#\">2</button></li><li class=\"page-item\"><button class=\"page-link\" href=\"#\">3</button></li>", 3)),
                            _createElementVNode("li", _hoisted_13, [
                                _createElementVNode("button", {
                                    class: "page-link",
                                    onClick: nextPage,
                                    disabled: page.value >= lastPage.value
                                }, "Siguiente", 8, _hoisted_14)
                            ])
                        ]),
                        _createElementVNode("span", _hoisted_15, "Página " + _toDisplayString(page.value) + " de " + _toDisplayString(lastPage.value), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        (groupSel.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5",
                                        id: "extendAccountLabel"
                                    }, "Se extenderá el grupo o cuenta"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("p", _hoisted_20, [
                                        _cache[6] || (_cache[6] = _createTextVNode("La cuenta ")),
                                        _createElementVNode("strong", null, _toDisplayString(groupSel.value.accountEmail), 1),
                                        _cache[7] || (_cache[7] = _createTextVNode(" será entendida"))
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "date",
                                                class: "form-control datepicker",
                                                id: "billingPeriod",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((expiredDate).value = $event); })
                                            }, null, 512), [
                                                [_vModelText, expiredDate.value]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("p", _hoisted_23, [
                                        _cache[8] || (_cache[8] = _createTextVNode("Por un costo de ")),
                                        _createElementVNode("strong", null, _toDisplayString(groupSel.value.currentCost), 1)
                                    ])
                                ]),
                                _createElementVNode("div", { class: "modal-footer" }, [
                                    _cache[9] || (_cache[9] = _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-secondary",
                                        "data-bs-dismiss": "modal"
                                    }, "Cancelar", -1)),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-primary",
                                        onClick: extendAccountConfirm
                                    }, "Contiuar")
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                        (groupSel.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5",
                                        id: "HistorialLabel"
                                    }, "Pagos realizados"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        (groupSel.value.costHistory.length === 0)
                                            ? (_openBlock(), _createElementBlock("h3", _hoisted_29, _cache[11] || (_cache[11] = [
                                                _createElementVNode("strong", null, "No se tienen registros históricos", -1)
                                            ])))
                                            : _createCommentVNode("", true),
                                        (groupSel.value.costHistory.length > 0)
                                            ? (_openBlock(), _createElementBlock("table", _hoisted_30, [
                                                _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("th", { scope: "col" }, "Periodo"),
                                                        _createElementVNode("th", { scope: "col" }, "Costo"),
                                                        _createElementVNode("th", { scope: "col" }, "Finaliza"),
                                                        _createElementVNode("th", { scope: "col" }, "Fecha de Registro")
                                                    ])
                                                ], -1)),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupSel.value.costHistory, function (item, index) {
                                                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                            _createElementVNode("td", null, _toDisplayString(_unref(dateFormat)(item.billingPeriod, 'YYYY-MM')), 1),
                                                            _createElementVNode("td", null, _toDisplayString(item.totalCost), 1),
                                                            _createElementVNode("td", null, _toDisplayString(_unref(dateFormat)(item.paymentDate, 'DD/MMM/YYYY')), 1),
                                                            _createElementVNode("td", null, _toDisplayString(_unref(dateFormat)(item.createdAt, 'DD/MMM/YYYY HH:mm:ss')), 1)
                                                        ]));
                                                    }), 128))
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "modal-footer" }, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-secondary",
                                        "data-bs-dismiss": "modal"
                                    }, "Cerrar")
                                ], -1))
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
